// extracted by mini-css-extract-plugin
module.exports = {"box":"_1LjcG","section":"qWrYR","storeBox":"_2QuCV"};